import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { getFirstDimensionId } from 'helpers/utils';
import { useGetProjectListsQuery } from 'pages/project-management/project-details/data-access/project.api';
import { Project } from '@app/shared/types/project.type';

const RECENT_PROJECTS_LIMIT = 5;

function sortByRecentFirst(projects: Project[]): Project[] {
  return [...projects].sort((a, b) => {
    const aDate = a.createdOn ? new Date(a.createdOn).getTime() : 0;
    const bDate = b.createdOn ? new Date(b.createdOn).getTime() : 0;
    return bDate - aDate;
  });
}

const MegaMenuRecentProjects = () => {
  const userId = localStorage.getItem('userId') || '';
  const environment = localStorage.getItem('SELECTED_ENV') || 'DEV';
  const organizationId = localStorage.getItem('organizationId') || '';

  const { data: projectList = [] } = useGetProjectListsQuery(
    { userId, environment, organizationId },
    {
      skip: !userId || !organizationId,
      refetchOnMountOrArgChange: true
    }
  );

  const recentProjects = sortByRecentFirst(projectList).slice(0, RECENT_PROJECTS_LIMIT);

  return (
    <div className="mega-menu-promo-card mega-menu-recent-projects h-100 rounded-3 d-flex flex-column align-items-start justify-content-start">
      <h4 className="mega-menu-section-title text-uppercase fw-bold mb-3 mega-menu-section-title-align text-black">
        Recently created projects
      </h4>
      <div className="mega-menu-section-items w-100">
        {recentProjects.length > 0 ? (
          <>
            {recentProjects.map(project => (
              <Link
                key={project.projectId}
                to={`/project/details-tabs?dimension-id=${getFirstDimensionId()}&projectId=${encodeURIComponent(
                  project.projectId
                )}`}
                className="mega-menu-item d-flex align-items-start gap-2 pt-4 rounded text-decoration-none mb-2 text-black"
                onClick={() => localStorage.setItem('projectId', project.projectId)}
              >
                <span className="mega-menu-item-icon flex-shrink-0 d-flex align-items-center">
                  <FeatherIcon icon="folder" size={22} className="text-body" />
                </span>
                <div className="mega-menu-item-content min-w-0">
                  <span className="fw-bold d-block mega-menu-item-title text-truncate">{project.title}</span>
                </div>
              </Link>
            ))}
          </>
        ) : (
          <p className="mega-menu-item-description text-black mb-0 mt-1">
            No recent projects. Create one from the menu.
          </p>
        )}
      </div>
    </div>
  );
};

export default MegaMenuRecentProjects;
